import React from 'react';
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';
import AsyncSelect from 'react-select/async';

/**
 * @classdesc Select input component
 */
export default class Select extends React.Component {
    /**
     * @constructor
     * @param {object} props
     */
    constructor(props) {
        super(props);

        this.state = {
            value: props.value ? props.value : [],
        };
    }

    /**
     * @method componentDidUpdate
     * @param {object} prevProps
     */
    componentDidUpdate = (prevProps) => {
        if (prevProps !== this.props && prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            });
        }
    };

    /**
     * @method onEdit
     * @param {object} value
     * @param {object} action
     */
    onEdit = (value, action) => {
        const original = this.state.value;
        let added;
        let removed;

        if (value && original && Array.isArray(value) && Array.isArray(original)) {
            removed = original.filter((v) => !value.includes(v));
            added = value.filter((v) => !original.includes(v));
        } else if (!value && original) {
            removed = Array.isArray(original) ? original : [original];
        } else if (value && !original) {
            added = Array.isArray(value) ? value : [value];
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, action);
        }

        if (added && added.length >= 1 && typeof this.props.onAdd === 'function') {
            this.props.onAdd(added);
        }
        if (removed && removed.length >= 1 &&
            typeof this.props.onRemove === 'function') {
            this.props.onRemove(removed);
        }

        this.setState({
            value,
        });
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const props = {...this.props};

        const animatedSelect = makeAnimated();

        const styles = {
            control: (styles) => ({
                ...styles,
                borderColor: props.error ? 'red' : styles.borderColor,
            }),
            menu: (styles) => Object.assign(styles, {zIndex: 10000}),
            placeholder: (styles) => Object.assign(styles, {fontSize: 14, color: '#a9a9a9'}),
        };

        props.onChange = this.onEdit;
        props.components = animatedSelect;
        props.value = this.state.value;
        props.styles = {
            ...styles,
            ...props.styles ?? {},
        };
        props.isMulti = (props.isMulti ?? props.multiple);

        if (this.props.async) {
            return (
                <AsyncSelect
                    {...props}
                    menuPosition="fixed"
                />
            );
        }

        return (
            <ReactSelect
                {...props}
                menuPosition={props.fixed === undefined || props.fixed === true ? 'fixed' : ''}
            />
        );
    };
}
